"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SharedImageBanner;
const react_1 = __importDefault(require("react"));
const dispatchAnalytics_1 = require("../../utils/dispatchAnalytics");
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/elements/button/Button");
const SharedImageBanner_module_scss_1 = __importDefault(require("./SharedImageBanner.module.scss"));
const buildImageUrl_1 = require("../../utils/buildImageUrl");
function SharedImageBanner({ title, description, ctaLink, ctaText, clickUrl, accessibilityText, desktopImage, impressionUrl, associatedAdvertId, logoImage, logoAccessibilityText, logo2Image, logo2AccessibilityText, testId = "shared", }) {
    const mobileSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, {
        fmt: "auto",
        w: "600",
        h: "1067", // 9:16 ratio
        sm: "c",
    });
    const tabletSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, {
        fmt: "auto",
        w: "1200",
        h: "400", // 3:1 ratio
        sm: "c",
    });
    const desktopSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, {
        fmt: "auto",
        w: "2560",
        h: "640", // 4:1 ratio
        sm: "c",
    });
    return (react_1.default.createElement("a", { href: ctaLink, "data-testid": `${testId}-image-banner-link`, onClick: () => {
            (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                action: "kevel.clicked",
                type: "banner",
                adId: associatedAdvertId,
                clickUrl,
                impressionUrl,
            });
        }, className: SharedImageBanner_module_scss_1.default.bannerLink },
        react_1.default.createElement("div", { className: SharedImageBanner_module_scss_1.default.imageContainer },
            react_1.default.createElement("picture", null,
                react_1.default.createElement("source", { media: "(min-width: 1024px)", srcSet: desktopSrc }),
                react_1.default.createElement("source", { media: "(min-width: 600px)", srcSet: tabletSrc }),
                react_1.default.createElement("img", { "data-testid": `${testId}-image-banner-main-image`, src: mobileSrc, alt: accessibilityText })),
            react_1.default.createElement("div", { className: SharedImageBanner_module_scss_1.default.contentContainer },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h2", { "data-testid": `${testId}-image-banner-title`, className: SharedImageBanner_module_scss_1.default.title }, title),
                    react_1.default.createElement("p", { "data-testid": `${testId}-image-banner-description`, className: SharedImageBanner_module_scss_1.default.description }, description),
                    react_1.default.createElement("div", { className: SharedImageBanner_module_scss_1.default.smallCtaContainer },
                        react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", size: "small", "data-testid": `${testId}-image-banner-small-cta` }, ctaText)),
                    react_1.default.createElement("div", { className: SharedImageBanner_module_scss_1.default.largeCtaContainer },
                        react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", size: "large", "data-testid": `${testId}-image-banner-large-cta` }, ctaText)))),
            react_1.default.createElement("div", { className: SharedImageBanner_module_scss_1.default.logosContainer },
                react_1.default.createElement("img", { src: logoImage, alt: logoAccessibilityText, "data-testid": `${testId}-image-banner-logo` }),
                logo2Image ? (react_1.default.createElement("img", { alt: logo2AccessibilityText || "", src: logo2Image, "data-testid": `${testId}-image-banner-logo-2` })) : null))));
}
